import CommonOperationClass from '../../../commonOperationClass';

const three = new CommonOperationClass('3');

export default three;
